import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download, Eye, BarChart2, Shield, LogIn } from "react-feather"; // Added Shield icon
import { Dropdown, Spinner } from "react-bootstrap";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2

const AllSellerAdmin = () => {
  const [sellers, setSellers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate(); // Initialize navigate

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // --- New Function for Full Access ---
  const handleGetAccess = (sellerId, sellerName) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to grant full access to this seller: ${sellerName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, grant access!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Navigate to the access route
        navigate(`/get-access/${sellerId}/${sellerName}`);
      }
    });
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);
    setFilteredData(
      sellers.filter((seller) =>
        `${seller.first_name} ${seller.middle_name || ""} ${seller.last_name}`
          .toLowerCase()
          .includes(term)
      )
    );
    setCurrentPage(1);
  };

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Seller Report");
    XLSX.writeFile(wb, "seller_report.xlsx");
  };

  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllSellersAdmin`);
        if (response.data.message === "Sellers fetched successfully") {
          setSellers(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching seller data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSellers();
  }, []);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4>All Sellers</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                value={search}
                className="form-control me-2"
                placeholder="Search Sellers"
                onChange={handleSearch}
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(sellers)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <button className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-body table-responsive">
              {loading ? (
                <div className="text-center my-5">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Seller Name</th>
                        <th>Email</th>
                        <th>Approved</th>
                        <th>Order Count</th>
                        <th>Created At</th>
                        <th>Order History</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.map((seller, index) => (
                        <tr key={index}>
                          <td>{indexOfFirstRecord + index + 1}</td>
                          <td>
                            {seller.first_name} {seller.middle_name} {seller.last_name}
                          </td>
                          <td>{seller.seller_email}</td>
                          <td>
                            {seller.approval ? (
                              <span className="badge bg-success">Approved</span>
                            ) : (
                              <span className="badge bg-danger">Not Approved</span>
                            )}
                          </td>
                          <td>{seller.total_cart_items}</td>
                          <td>{new Date(seller.created_at).toLocaleDateString()}</td>
                          <td>
                            <Link to={`/admin/seller-order/${seller.id}`} className="btn btn-primary btn-sm">
                              <BarChart2 size={15} /> Orders
                            </Link>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Link
                                to={`/admin/seller-detail/${seller.seller_unique_id}`}
                                className="btn btn-info btn-sm"
                                title="View Details"
                              >
                                <Eye size={15} />
                              </Link>
                              
                              {/* --- New Action Button --- */}
                              <button
                                onClick={() => handleGetAccess(seller.id, seller.first_name)}
                                className="btn btn-warning btn-sm"
                                title="Get Full Access"
                              >
                                <LogIn size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Pagination Controls */}
                  <nav>
                    <ul className="pagination justify-content-end">
                      {[...Array(totalPages)].map((_, i) => (
                        <li
                          className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                          key={i}
                          onClick={() => setCurrentPage(i + 1)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="page-link">{i + 1}</span>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllSellerAdmin;